// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"1e1a1d18","254":"50000353"}[chunkId] + ".chunk.js";
};